import React, { ComponentProps } from 'react';

import { Link as ZinniaLink } from '@zapier/design-system';

import BlockLink from './BlockLink';

type Props = ComponentProps<typeof BlockLink | typeof ZinniaLink> & {
  anchor?: string;
};

const defaultProps = {
  anchor: undefined,
};

function Link(props: Props) {
  const { anchor = defaultProps.anchor, children, href, onPress } = props;
  const isBlockLink = typeof children !== 'string';
  const LinkComponent = isBlockLink ? BlockLink : ZinniaLink;
  const hrefComplete = href ? `${href}${anchor || ''}` : undefined;

  return (
    <LinkComponent {...props} href={hrefComplete} onPress={onPress}>
      {children}
    </LinkComponent>
  );
}

Link.defaultProps = defaultProps;

export default Link;
